import { render, staticRenderFns } from "./RegisterFromInvite.vue?vue&type=template&id=10594afb&scoped=true"
import script from "./RegisterFromInvite.vue?vue&type=script&lang=js"
export * from "./RegisterFromInvite.vue?vue&type=script&lang=js"
import style0 from "./RegisterFromInvite.vue?vue&type=style&index=0&id=10594afb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10594afb",
  null
  
)

export default component.exports